// Generated types for PhysicalPart
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { SourcingStatus } from '../enums';

import { PartReadAPI, PartWriteAPI } from './part';
import { PartReadAPISchemaObject, PartWriteAPISchemaObject } from './part';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface PhysicalPartReadAPI extends Omit<PartReadAPI, 'description'> {
  /** What this PhysicalPart is (SKU / vendor / role) and why it was selected. Required when authoring via the agent (LLM tool surface); optional for direct REST callers. */
  description?: string | null;
  /** Manufacturer / vendor name. */
  manufacturer?: string | null;
  /** SKU / part number. */
  part_number?: string | null;
  /** Unit cost (procurement-universal). */
  cost?: number | null;
  /** Lead time in days. */
  lead_time_days?: number | null;
  /** Link to datasheet. */
  datasheet_url?: string | null;
  /** Procurement lifecycle status. */
  sourcing_status?: SourcingStatus;
}

export interface PhysicalPartWriteAPI extends Omit<PartWriteAPI, 'description'> {
  /** What this PhysicalPart is (SKU / vendor / role) and why it was selected. Required when authoring via the agent (LLM tool surface); optional for direct REST callers. */
  description?: string | null;
  /** Manufacturer / vendor name. */
  manufacturer?: string | null;
  /** SKU / part number. */
  part_number?: string | null;
  /** Unit cost (procurement-universal). */
  cost?: number | null;
  /** Lead time in days. */
  lead_time_days?: number | null;
  /** Link to datasheet. */
  datasheet_url?: string | null;
  /** Procurement lifecycle status. */
  sourcing_status?: SourcingStatus;
  parent?: string;
  children?: (string | PhysicalPartWriteAPI)[];
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const PhysicalPartReadAPISchema: z.ZodType<PhysicalPartReadAPI> = PartReadAPISchemaObject.omit({ 'description': true }).extend({
  description: z.string().nullable().optional(),
  manufacturer: z.string().nullable().optional(),
  part_number: z.string().nullable().optional(),
  cost: z.number().nullable().optional(),
  lead_time_days: z.number().nullable().optional(),
  datasheet_url: z.string().nullable().optional(),
  sourcing_status: z.nativeEnum(SourcingStatus).optional(),
}).passthrough();

export const PhysicalPartWriteAPISchema: z.ZodType<PhysicalPartWriteAPI> = PartWriteAPISchemaObject.omit({ 'description': true }).extend({
  description: z.string().nullable().optional(),
  manufacturer: z.string().nullable().optional(),
  part_number: z.string().nullable().optional(),
  cost: z.number().nullable().optional(),
  lead_time_days: z.number().nullable().optional(),
  datasheet_url: z.string().nullable().optional(),
  sourcing_status: z.nativeEnum(SourcingStatus).optional(),
  parent: z.string().optional(),
  children: z.array(z.union([z.string(), z.lazy(() => PhysicalPartWriteAPISchema)])).optional(),
}).passthrough();
